import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import PollAnswerForm from "../components/PollAnswerForm";
import { useAuth } from "../contexts/AuthContext";

export default function PollAnswerPage() {
  const { programItemId } = useParams<{ programItemId: string }>();
  const { user } = useAuth();
  const [groups, setGroups] = useState<any[]>([]);
  const [options, setOptions] = useState<any[]>([]);
  const [allowAbstain, setAllowAbstain] = useState(false);
  const [loading, setLoading] = useState(true);
  const [existingAnswers, setExistingAnswers] = useState<any[]>([]);

  useEffect(() => {
    if (!programItemId || !user?.id) return;

    const fetchData = async () => {
      const { data: item } = await supabase
        .from("trip_program_items")
        .select("poll_allow_abstain")
        .eq("id", programItemId)
        .single();

      const { data: g } = await supabase
        .from("trip_program_poll_option_groups")
        .select("*")
        .eq("program_item_id", programItemId);

      const groupIds = g?.map((gr) => gr.id) || [];

      const { data: o } = await supabase
        .from("trip_program_poll_options")
        .select("*")
        .in("option_group_id", groupIds);

      const { data: a } = await supabase
        .from("trip_program_poll_responses")
        .select("*")
        .eq("program_item_id", programItemId)
        .eq("user_id", user.id);

      const updatedOptions: any[] = [...(o || [])];

      // Für Gruppen, die nicht Pflicht sind → "Keine Wahl" hinzufügen
      g?.forEach((group) => {
        if (!group.is_required) {
          updatedOptions.push({
            id: `none-${group.id}`,
            option_group_id: group.id,
            label: "Keine Wahl",
            is_none_option: true,
          });
        }
      });

      setGroups(g || []);
      setOptions(updatedOptions);
      setAllowAbstain(item?.poll_allow_abstain || false);
      setExistingAnswers(a || []);
      setLoading(false);
    };

    fetchData();
  }, [programItemId, user?.id]);

  if (loading) return <p>⏳ Lade Umfrage…</p>;
  if (!programItemId) return <p>❌ Ungültiger Link.</p>;

  return (
    <div className="max-w-2xl mx-auto mt-8 p-4">
      <h1 className="text-xl font-bold mb-4">🗳 Umfrage beantworten</h1>
      <PollAnswerForm
        programItemId={programItemId}
        groups={groups}
        options={options}
        allowAbstain={allowAbstain}
        existingAnswers={existingAnswers}
      />
    </div>
  );
}
